import React from 'react';
import { Container } from 'react-bootstrap';
import OrganizationManager from '../organizations/OrganizationManager';

export default function Organizations() {
  return (
    <Container fluid className="p-4">
      <h2 className="mb-4">Organizaciones</h2>
      <OrganizationManager />
    </Container>
  );
}
